import React, { useContext } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { FirebaseContext } from './Firebase'
import {Title} from '../components/common/title'


const HeroSection = styled.div`
  max-width: 100%;
  width: 100wh;
  background: var(--background);
  background-size:cover;
  background-position: center;
  margin:auto auto;

/* mobile query  */
   @media (max-width: 750px) {
    align-content: center;
    justify-content: center;
    margin-top: 1.5rem;
  }
`
const HeroGroup = styled.div`
  width:100%;
  margin: 1rem 0;
  display:flex;
  flex-direction: column;
  text-align: center;
  align-content: center;
  
  /* @media (min-width: 750px) {
      text-align:center;
    margin-top: 2.7rem;
    width:70vw;
    max-width: 85%;
  } */

  
  p {
    font-size: .7rem;
    line-height:1.3;
    width:90%;
    max-width:90%;
    align-self:center;
    opacity: 0;
    animation: HeroAnimation 3s 0.3s forwards cubic-bezier(0.2, 0.8, 0.2, 1);
   /* Desktop styles */
    @media (min-width: 750px) {
      font-size: 1.3rem;
      width:70%;
      max-width:70%;
    }
  }

  @keyframes HeroAnimation {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
`
const StyledLink = styled(Link)`
  margin-top: 1.5rem;
  font-size: 17px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  background: var(--blue-500);
  padding: 9px 20px;
  border: 1px solid rgba(255,255,255, 1);
  border-radius: 20px;
  max-width:20ch;
  align-self:center;
  :hover{
    color:var(--blue-500);
    background:white;
    cursor: pointer;
  }
`
const Hero = () => {

  const { userAuth } = useContext(FirebaseContext);

  return (
    <HeroSection>
      <HeroGroup>
        <Title>Ajutorul Educatorului</Title>
        <p>Nr.1 în fișe online cu mai mult timp pentru tine!</p>
        <p>Materiale educaționale pentru preșcolari <br/>gata să fie folosite la clasă.</p>
        <p>Fără pregătiri suplimentare.</p>
        <p>Mai mult timp liber pentru tine.</p>
        {!userAuth && <StyledLink to='/register'>
          Vreau acces
        </StyledLink>}
      </HeroGroup>
    </HeroSection>
  )
}

export default Hero
